/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_From_SquadInputs */

const th_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นำออก`)
};

const en_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const ja_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外す`)
};

const zh_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const es_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar`)
};

const pt_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover`)
};

const id_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluarkan`)
};

const fr_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer`)
};

const tl_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alisin`)
};

const vi_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

const ko_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제외`)
};

const de_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const ru_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Убрать`)
};

const tr_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkar`)
};

const it_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi`)
};

const pl_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuń`)
};

const uk_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прибрати`)
};

const hi_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाएँ`)
};

const ar_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إزالة`)
};

const ms_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluarkan`)
};

const bn_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরান`)
};

const zh_tw2_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const zh_hk2_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const ur_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ہٹائیں`)
};

const fa_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف`)
};

const sw_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondoa`)
};

const nl_remove_from_squad = /** @type {(inputs: Remove_From_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Remove_From_SquadInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const remove_from_squad = /** @type {((inputs?: Remove_From_SquadInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_From_SquadInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_remove_from_squad(inputs)
	if (locale === "ja") return ja_remove_from_squad(inputs)
	if (locale === "zh") return zh_remove_from_squad(inputs)
	if (locale === "es") return es_remove_from_squad(inputs)
	if (locale === "pt") return pt_remove_from_squad(inputs)
	if (locale === "id") return id_remove_from_squad(inputs)
	if (locale === "fr") return fr_remove_from_squad(inputs)
	if (locale === "tl") return tl_remove_from_squad(inputs)
	if (locale === "vi") return vi_remove_from_squad(inputs)
	if (locale === "ko") return ko_remove_from_squad(inputs)
	if (locale === "de") return de_remove_from_squad(inputs)
	if (locale === "ru") return ru_remove_from_squad(inputs)
	if (locale === "tr") return tr_remove_from_squad(inputs)
	if (locale === "it") return it_remove_from_squad(inputs)
	if (locale === "pl") return pl_remove_from_squad(inputs)
	if (locale === "uk") return uk_remove_from_squad(inputs)
	if (locale === "hi") return hi_remove_from_squad(inputs)
	if (locale === "ar") return ar_remove_from_squad(inputs)
	if (locale === "ms") return ms_remove_from_squad(inputs)
	if (locale === "bn") return bn_remove_from_squad(inputs)
	if (locale === "zh-TW") return zh_tw2_remove_from_squad(inputs)
	if (locale === "zh-HK") return zh_hk2_remove_from_squad(inputs)
	if (locale === "ur") return ur_remove_from_squad(inputs)
	if (locale === "fa") return fa_remove_from_squad(inputs)
	if (locale === "sw") return sw_remove_from_squad(inputs)
	if (locale === "nl") return nl_remove_from_squad(inputs)
	return en_remove_from_squad(inputs)
});